import React from 'react';
import PropTypes from 'prop-types';

import IconSpothero from '@spothero/icons/spothero';
import {Box, Heading, Text, Link, Icon} from '@spothero/ui';
import {
    headerStyleProps,
    headerTextStyleProps,
    headerTitleStyleProps,
    widgetHeaderLogoStyleProps,
} from './WidgetHeaderStyleProps';

const WidgetHeader = ({destinationId, destinationName, trackingLink}) => {
    return (
        <Box {...headerStyleProps}>
            <Link
                target="_parent"
                href={
                    destinationId
                        ? `${trackingLink}&kind=destination&id=${destinationId}`
                        : `${trackingLink}`
                }
                aria-label="Link To SpotHero"
            >
                <Icon as={IconSpothero} {...widgetHeaderLogoStyleProps} />
            </Link>
            <Heading as="h2" {...headerTitleStyleProps}>{`Stay with ${
                destinationName || 'us!'
            }, park with SpotHero`}</Heading>
            <Text {...headerTextStyleProps}>
                Book parking in advance for a stress-free visit
            </Text>
        </Box>
    );
};

WidgetHeader.propTypes = {
    trackingLink: PropTypes.string.isRequired,
    destinationId: PropTypes.number,
    destinationName: PropTypes.string.isRequired,
};

export default WidgetHeader;
